import {
	Box,
	Button,
	Flex,
	FormControl,
	FormLabel,
	HStack,
	Input,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalHeader,
	ModalOverlay,
	Select,
	Spinner,
	Text,
	Textarea,
	Menu,
	MenuButton,
	MenuList,
	MenuItem,
	useDisclosure,
} from "@chakra-ui/react";
import { decryptResponse } from "../../../allApi/interceptorsApiCall";
import { useState, useRef } from "react";
import { ChevronDownIcon, AddIcon } from "@chakra-ui/icons";
import {
	geetingNameListModel,
	setModelApi,
	testModelApi,
	getAliBabaModelsApi,
	geetingOpenAIModels,
	getBedrockModelsApi,
} from "../../../allApi/api";
import { useDispatch, useSelector } from "react-redux";
import formatDate from "./DateSet";
import { useCustomTost } from "../../../utiils/useCustomTost";
import axios from "axios";

const models = [
	{ name: "together", description: "together" },
	{ name: "groq", description: "groq" },
	{ name: "OpenAI", description: "openAI" },
	// { name: "mistral", description: "mistral" }, // Commented for now as there is no backend logic
	// { name: "deepseek", description: "deepseek" }, // Commented for now as there is no backend logic
	{ name: "gemini", description: "gemini" },
	{ name: "alibaba", description: "alibaba" },
	{ name: "aws-bedrock", description: "aws-bedrock" },
];

function ModalOpen({ onAdd }) {
	const [testModal, setTestModal] = useState("");
	const [testLoader, setTestLoader] = useState(false);
	const { isOpen, onOpen, onClose } = useDisclosure();
	const [modelnameList, setModelnameList] = useState([]);
	const [modelNameLoader, setModelNameLoader] = useState(false);
	const toast = useCustomTost();
	const buttonRef = useRef(null);

	const initialFormState = {
		client: "",
		model_name: "",
		api_key: "",
		base_url: "",
		description: "",
		aws_access_key_id: "",
		aws_secret_access_key: "",
		aws_session_token: "",
		aws_region: "",
		date: formatDate(new Date()),
	};

	const [formData, setFormData] = useState(initialFormState);

	const resetForm = () => {
		setFormData(initialFormState);
		setTestModal("");
		setModelnameList([]);
	};

	const handleChange = async (e) => {
		const { name, value } = e.target;

		if (name === "client") {
			setModelnameList([]);
			setFormData({ ...formData, model_name: "" });

			try {
				setModelNameLoader(true);

				if (value === "together") {
					const data = await geetingNameListModel("together");
					setModelnameList(data);
					setFormData((prev) => ({
						...prev,
						base_url: "https://api.together.xyz/v1",
					}));
				}

				if (value === "groq") {
					const data = await geetingNameListModel("groq");
					setModelnameList(data);
					setFormData((prev) => ({
						...prev,
						base_url: "https://api.groq.com/openai/v1",
					}));
				}

				if (value === "OpenAI") {
					const data = await geetingOpenAIModels();
					setModelnameList(data);
					setFormData((prev) => ({
						...prev,
						base_url: "https://api.openai.com/v1/",
					}));
				}

				if (value === "aws-bedrock") {
					setFormData((prev) => ({
						...prev,
						base_url: "",
						api_key: "",
						aws_region: "",
					}));
				}

				if (value === "alibaba") {
					const data = await getAliBabaModelsApi();
					setModelnameList(data);
					setFormData((prev) => ({
						...prev,
						base_url: "https://dashscope-intl.aliyuncs.com/compatible-mode/v1",
					}));
				}

				if (value === "gemini") {
					const data = await geetingNameListModel("gemini");
					setModelnameList(data);
					setFormData((prev) => ({
						...prev,
						base_url:
							"https://generativelanguage.googleapis.com/v1beta/openai/",
					}));
				}

				if (value === "mistral") {
					setFormData((prev) => ({ ...prev, base_url: "" }));
				}

				if (value === "deepseek") {
					setFormData((prev) => ({
						...prev,
						base_url: "https://api.deepseek.com/v1",
					}));
				}
			} finally {
				setModelNameLoader(false);
			}
		}

		if (name === "aws_region") {
			setFormData((prev) => ({
				...prev,
				aws_region: value,
				base_url: prev.client === "aws-bedrock" ? `https://bedrock-runtime.${value}.amazonaws.com` : prev.base_url,
			}));
			return;
		}

		setFormData((prev) => ({ ...prev, [name]: value }));
	};

	const handleSave = async () => {
		setTestModal("");
		try {
			const payload = { ...formData };
			if (payload.client === "aws-bedrock" && !payload.aws_session_token) {
				payload.aws_session_token = null;
			}
			const response = await setModelApi(payload);
			if (response?.model) {
				const newModel = response.model_details;
				onAdd(newModel);
				toast("Success!", "Model saved successfully.", "success");
				resetForm();
				onClose();
			}
		} catch (error) {
			console.error("Save failed", error);
		}
	};

	const extractErrorMessage = (error) => {
		const data = error?.response?.data;

		// 1. Get raw string
		let rawString =
			data?.detail ||
			data?.message ||
			(typeof data === "string" ? data : "") ||
			error?.message ||
			"Unknown error";

		// 2. Regex Extraction (for Python/JSON dumps)
		const messageMatch = rawString.match(
			/['"]message['"]:\s*(['"])([\s\S]*?)\1/
		);
		let finalMessage = rawString;

		if (messageMatch && messageMatch[2]) {
			finalMessage = messageMatch[2];
		} else {
			// Clean up standard prefixes
			finalMessage = rawString
				.replace(/^Health check failed:?\s*/i, "")
				.replace(/^Error code:\s*\d+\s*-\s*/i, "")
				.trim();
		}

		// --- CUSTOM OVERRIDES ---

		const lowerMsg = finalMessage.toLowerCase();

		// Case 1: Server Error (500)
		if (lowerMsg.includes("internal server error")) {
			return "Model currently unavailable (Provider Error 500)";
		}

		// Case 2: Classification/Guard Models
		if (
			lowerMsg.includes("text classification models") ||
			lowerMsg.includes("failed to template request")
		) {
			return "This model is not supported for chat (Classification Model Only)";
		}

		// Case 3: Completion vs Chat Mismatch
		if (
			lowerMsg.includes("not a chat model") ||
			lowerMsg.includes("v1/chat/completions")
		) {
			return "This model is not compatible with chat (Completion-only model)";
		}

		// Case 4: Embedding vs Chat Mismatch (NEW)
		if (
			lowerMsg.includes("not supported for generatecontent") ||
			lowerMsg.includes("embedding")
		) {
			return "This is an embedding model, not a chat model";
		}

		// Case 5: Quota / Rate Limit (NEW)
		if (
			lowerMsg.includes("quota exceeded") ||
			lowerMsg.includes("rate limit")
		) {
			return "Quota exceeded. Please check your billing details or try again later.";
		}

		if (
			lowerMsg.includes("developer instruction is not enabled") ||
			lowerMsg.includes("system instruction")
		) {
			return "This model does not support system/developer instructions.";
		}

		return finalMessage;
	};

	const testModelApi1 = async (payload) => {
		try {
			const API_URL = process.env.REACT_APP_API_URL;

			// 1. Retrieve values from localStorage (Replicating your interceptor logic)
			const token = localStorage.getItem("token");
			const session_id = localStorage.getItem("session_id");
			const userEmailId = localStorage.getItem("user_mailId");
			const userName = localStorage.getItem("user_name");

			// 2. Construct the headers object
			const headers = {
				"Content-Type": "application/json",
			};

			// Conditionally add headers if they exist
			if (token) {
				headers.Authorization = `Bearer ${token}`;
			}
			if (userEmailId) {
				headers.Userid = userEmailId;
			}
			if (session_id) {
				headers.Sessionid = session_id;
			}
			if (userName && userName !== "undefined") {
				headers["userName"] = userName;
			}

			// 3. Make the raw axios call using these manual headers
			const response = await axios.post(
				`${API_URL}/model_health_check`,
				payload,
				{
					headers: headers,
				}
			);

			return decryptResponse(response.data);
		} catch (error) {
			// Throw error to let the component handle the "Model not compatible" toast
			throw error;
		}
	};

	// const handleTest = async () => {
	// 	setTestModal("");
	// 	setTestLoader(true);
	// 	try {
	// 		const response = await testModelApi1(formData);
	// 		if (response?.message === "success") {
	// 			setTestModal("success");
	// 		} else {
	// 			setTestModal(
	// 				`Could you review the API Key and see if ${formData.model_name} works with chat?`
	// 			);
	// 			// setTestModal(response?.message); this is commented for now
	// 		}
	// 	} catch (error) {
	// 		setTestModal(
	// 			`Could you review the API Key and see if ${formData.model_name} works with chat?`
	// 		);
	// 		// console.error("Test failed details:", error);
	// 	} finally {
	// 		setTestLoader(false);
	// 	}
	// };

	const handleTest = async () => {
		setTestModal("");
		setTestLoader(true);
		try {
			const payload = { ...formData };
			if (payload.client === "aws-bedrock" && !payload.aws_session_token) {
				payload.aws_session_token = null;
			}
			const response = await testModelApi1(payload);

			// Handle 200 OK but logical failure (if your API does that)
			if (response?.message === "success") {
				setTestModal("success");
			} else {
				// If response is 200 but contains an error message structure
				const msg =
					response?.detail || response?.message || "Validation failed";
				// Attempt to extract clean message, otherwise show raw
				const cleanMsg =
					msg.match(/['"]message['"]:\s*(['"])(.*?)\1/)?.[2] || msg;
				setTestModal(cleanMsg);
			}
		} catch (error) {
			// Use the helper to get the real error
			const preciseError = extractErrorMessage(error);
			setTestModal(preciseError);

			console.error("Full error details:", error); // Keep for debugging
		} finally {
			setTestLoader(false);
		}
	};

	const handleOpen = () => {
		resetForm();
		onOpen();
	};

	return (
		<>
			<Flex p="4">
				<Button
					rightIcon={<AddIcon />}
					size="sm"
					bgGradient="linear(to-r, purple.400, blue.500)"
					color="white"
					_hover={{
						bgGradient: "linear(to-r, purple.500, blue.600)",
						boxShadow: "md",
					}}
					borderRadius="md"
					px="4"
					py="2"
					onClick={handleOpen}
				>
					New Model
				</Button>
			</Flex>

			<Modal
				blockScrollOnMount={false}
				isOpen={isOpen}
				onClose={() => {
					resetForm();
					onClose();
				}}
				size="xl"
			>
				<ModalOverlay />
				<ModalContent maxW="800px">
					<ModalCloseButton />
					<ModalHeader>
						<Text fontWeight={600} fontSize="lg">
							Model Specification
						</Text>
						<Text fontSize="sm" color="gray.500">
							Select model type and enter parameters for your model type
						</Text>
					</ModalHeader>

					<ModalBody pb={6}>
						<Flex justify="center" align="flex-start">
							<Box w="100%" bg="white" rounded="md">
								<FormControl mb={4} isRequired>
									<FormLabel fontSize="sm" color="gray.600">
										Model Provider
									</FormLabel>
									<Select
										color={formData.client ? "black" : "gray.500"}
										value={formData.client}
										onChange={handleChange}
										name="client"
										size="sm"
										bg="gray.100"
									>
										<option hidden disabled value="">
											Model Provider
										</option>
										{models.map((model) => (
											<option key={model.name} value={model.name}>
												{model.name}
											</option>
										))}
									</Select>
								</FormControl>

								<HStack spacing={4} mb={4}>
									<FormControl isRequired>
										<FormLabel fontSize="sm" color="gray.600">
											Model
										</FormLabel>
										{formData.client === "aws-bedrock" ? (
											<Input
												name="model_name"
												value={formData.model_name}
												onChange={handleChange}
												placeholder="e.g. anthropic.claude-v2"
												bg="gray.100"
												size="sm"
											/>
										) : (
											<Menu>
												<MenuButton
													as={Button}
													ref={buttonRef}
													rightIcon={<ChevronDownIcon />}
													size="sm"
													bg="gray.100"
													color={formData.model_name ? "black" : "gray.500"}
													isDisabled={modelNameLoader || !modelnameList.length}
													textAlign="left"
													w="100%"
													fontWeight="normal"
												>
													{modelNameLoader
														? "Loading models..."
														: formData.model_name || "Select Model"}
												</MenuButton>

												<MenuList
													maxH="200px"
													overflowY="auto"
													minW={
														buttonRef.current
															? `${buttonRef.current.offsetWidth}px`
															: "100%"
													}
												>
													{!modelnameList.length ? (
														<Box px={4} py={2}>
															<Text fontSize="sm" color="gray.500">
																No models found
															</Text>
														</Box>
													) : (
														modelnameList.map((model) => (
															<MenuItem
																key={model}
																onClick={() => {
																	let selectedModel = model;

																	// Apply "us." prefix to ALL Bedrock models
																	if (
																		formData.client === "aws-bedrock" &&
																		!model.startsWith("us.")
																	) {
																		selectedModel = `us.${model}`;
																	}

																	setFormData((prev) => ({
																		...prev,
																		model_name: selectedModel,
																	}));
																}}
															>
																{model}
															</MenuItem>
														))
													)}
												</MenuList>
											</Menu>
										)}
									</FormControl>

									{formData.client !== "aws-bedrock" && (
										<FormControl isRequired>
											<FormLabel fontSize="sm" color="gray.600">
												API Key
											</FormLabel>
											<Input
												name="api_key"
												type="password"
												value={formData.api_key}
												onChange={handleChange}
												placeholder="API Key"
												bg="gray.100"
												size="sm"
											/>
										</FormControl>
									)}
								</HStack>

								{formData.client === "aws-bedrock" && (
									<>
										<HStack spacing={4} mb={4}>
											<FormControl isRequired>
												<FormLabel fontSize="sm" color="gray.600">
													Access Key ID
												</FormLabel>
												<Input
													name="aws_access_key_id"
													value={formData.aws_access_key_id}
													onChange={handleChange}
													placeholder="AKIA..."
													bg="gray.100"
													size="sm"
												/>
											</FormControl>
											<FormControl isRequired>
												<FormLabel fontSize="sm" color="gray.600">
													Secret Access Key
												</FormLabel>
												<Input
													name="aws_secret_access_key"
													type="password"
													value={formData.aws_secret_access_key}
													onChange={handleChange}
													placeholder="Secret Key"
													bg="gray.100"
													size="sm"
												/>
											</FormControl>
										</HStack>
										<HStack spacing={4} mb={4}>
											<FormControl>
												<FormLabel fontSize="sm" color="gray.600">
													Session Token
												</FormLabel>
												<Input
													name="aws_session_token"
													type="password"
													value={formData.aws_session_token}
													onChange={handleChange}
													placeholder="Session Token (Optional)"
													bg="gray.100"
													size="sm"
												/>
											</FormControl>
											<FormControl isRequired>
												<FormLabel fontSize="sm" color="gray.600">
													AWS Region
												</FormLabel>
												<Input
													name="aws_region"
													value={formData.aws_region}
													onChange={handleChange}
													placeholder="e.g. ap-south-1"
													bg="gray.100"
													size="sm"
												/>
											</FormControl>
										</HStack>
									</>
								)}

								<FormControl mb={4}>
									<FormLabel fontSize="sm" color="gray.600">
										Base URL
									</FormLabel>
									<Input
										name="base_url"
										value={formData.base_url}
										onChange={handleChange}
										placeholder="Base URL"
										bg="gray.100"
										size="sm"
									/>
								</FormControl>

								<FormControl mb={4}>
									<FormLabel fontSize="sm" color="gray.600">
										Description
									</FormLabel>
									<Textarea
										name="description"
										value={formData.description}
										onChange={handleChange}
										placeholder="Description"
										bg="gray.100"
										size="sm"
									/>
								</FormControl>
							</Box>
						</Flex>
					</ModalBody>

					<Flex justify="flex-end" gap={3} px={6} py={4}>
						{testModal && (
							<Text
								bg={testModal === "success" ? "green.500" : "red.500"}
								color="white"
								px={3}
								py={2}
								borderRadius="md"
								fontSize="xs"
								maxW="50%"
								whiteSpace="normal"
								textAlign="left"
								lineHeight="short"
							>
								{testModal}
							</Text>
						)}
						<Button colorScheme="purple" onClick={handleTest}>
							{testLoader && <Spinner size="sm" mr="2" />}
							{testLoader ? "Testing" : "Test"}
						</Button>
						<Button
							isDisabled={testModal !== "success"}
							colorScheme="purple"
							onClick={handleSave}
						>
							Save
						</Button>
						<Button
							onClick={() => {
								resetForm();
								onClose();
							}}
						>
							Cancel
						</Button>
					</Flex>
				</ModalContent>
			</Modal>
		</>
	);
}

export default ModalOpen;
